<template>
  <bottom-sheet
    :visible="visible"
    :close-icon-right-align="addVehicleView"
    @close="$emit('close')"
  >
    <div
      v-if="addVehicleView"
      class="-mt-6 px-2"
    >
      <div class="flex items-center gap-2">
        <img
          class="cursor-pointer"
          src="@/assets/back-icon-gray.svg"
          alt="back icon"
          @click="handleBack"
        />

        <h4 class="text-left text-2xl text-dark-blue">Add Vehicle</h4>
      </div>

      <div class="mt-4">
        <p class="mb-2 text-left font-semibold text-neutral-subtle">
          VIN number <span class="pl-[2px] text-red-500">*</span>
        </p>
        <input
          v-model="vinInput"
          placeholder="Enter number"
          type="text"
          class="w-full rounded-md border border-light-gray bg-off-white px-3 py-2 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
        />

        <p class="mb-2 text-left font-semibold text-neutral-subtle">
          Truck number <span class="pl-[2px] text-red-500">*</span>
        </p>
        <input
          v-model="truckInput"
          placeholder="Enter number"
          type="text"
          class="w-full rounded-md border border-light-gray bg-off-white px-3 py-2 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
        />
      </div>

      <button-main
        class="mb-2 mt-8 text-1md !text-white"
        variant="secondary"
        custom-bg="#374053"
        :disabled="!vinInput || !truckInput"
        @click="handleAddVehicle"
      >
        Add Vehicle
      </button-main>
    </div>

    <div
      v-else
      class="px-2"
    >
      <h4 class="text-left text-2xl text-dark-blue">Assign Vehicle</h4>
      <span
        class="absolute right-4 top-4 cursor-pointer"
        @click="handleMissingVehicle"
      >
        <p>I don't see my vehicle</p>
      </span>
      <div class="relative mt-2">
        <input
          v-model="searchText"
          type="text"
          class="h-9 w-full rounded-md border-light-gray bg-lighter-gray bg-opacity-30 pl-8 pr-3 text-sm text-gray-500 shadow-sm outline-none"
          placeholder="Search Vehicles"
          @input="search"
        />
        <button
          type="submit"
          class="absolute bottom-0 left-2 top-0 flex w-8 flex-col justify-center bg-transparent text-placeholder-gray hover:text-yellow-500"
        >
          <img
            class="h-4 w-4 cursor-pointer"
            src="@/assets/search-light-gray.svg"
            alt="search icon"
          />
        </button>
      </div>

      <div class="my-4 max-h-[400px] overflow-scroll">
        <round-radio-button
          v-for="vin in vins"
          :key="vin.id"
          :item="vin.truck_number || '-'"
          :subtext="vin?.vehicle?.vin"
          name="vin"
          :value="vin.truck_number"
          :show="true"
          :checked="selectedVin === vin.truck_number"
          :handle-click="
            ($event) => handleSelectRadio($event, vin.truck_number)
          "
        />
      </div>

      <button-main
        class="my-2 text-1md"
        :disabled="!selectedVin"
        @click="handleAssignVehicle"
      >
        Assign
      </button-main>
    </div>
  </bottom-sheet>
</template>

<script>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import debounce from 'lodash.debounce';
import BottomSheet from '@/components/BottomSheet.vue';
import RoundRadioButton from '@/components/RoundRadioButtonLoads.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'AssignVehicleBottomSheet',
  components: {
    BottomSheet,
    RoundRadioButton,
    ButtonMain,
  },
  props: {
    visible: Boolean,
  },
  emits: ['close'],
  setup: (_, { emit }) => {
    const store = useStore();

    const vins = computed(() => store.state.loads?.eld_carrier_vehicles);
    const filteredVins = ref([...vins.value]);
    const searchText = ref('');

    const selectedVin = ref('');
    const addVehicleView = ref(false);
    const vinInput = ref('');
    const truckInput = ref('');

    const handleSelectRadio = (item, value) => {
      selectedVin.value = value;
    };

    const search = debounce(() => {
      if (searchText.value?.length === 0) {
        filteredVins.value = vins.value;
      } else {
        const text = searchText.value?.toLowerCase();

        const filtered = vins.value?.filter(
          (vin) =>
            vin?.truck_number?.toLowerCase()?.includes(text) ||
            vin?.vehicle?.vin?.toLowerCase()?.includes(text)
        );

        filteredVins.value = filtered;
      }
    }, 500);

    const handleAssignVehicle = () => {
      console.log('Assign Vehicle', selectedVin.value);

      emit('assign-vin', selectedVin.value);
      emit('close');
    };

    const handleMissingVehicle = () => {
      console.log('I dont see my vehicle');

      addVehicleView.value = true;
    };

    const handleAddVehicle = () => {
      console.log('ADD VEHICLE');

      // addVehicleView.value = true;
    };

    const handleBack = () => {
      addVehicleView.value = false;
    };

    return {
      search,
      vinInput,
      truckInput,
      searchText,
      handleBack,
      selectedVin,
      addVehicleView,
      handleAddVehicle,
      handleSelectRadio,
      vins: filteredVins,
      handleAssignVehicle,
      handleMissingVehicle,
    };
  },
};
</script>
